
import React from 'react';
import { Leaf, Heart, Flame } from 'lucide-react';

const benefits = [
  {
    icon: Leaf,
    title: "100% натуральный воск",
    description: "Используем только чистый пчелиный воск высшего качества"
  },
  {
    icon: Heart,
    title: "Ручная работа",
    description: "Каждая свеча создается вручную с особым вниманием к деталям"
  },
  {
    icon: Flame,
    title: "Долгое горение",
    description: "Наши свечи горят дольше и дают мягкий, теплый свет"
  }
];

const Benefits = () => {
  return (
    <section className="py-24 bg-wax-50">
      <div className="container px-4">
        <div className="text-center mb-16">
          <h2 className="font-cormorant-garamond text-4xl font-bold mb-4">Почему выбирают нас</h2>
          <p className="text-gray-600 max-w-2xl mx-auto">
            Мы создаем свечи, которые наполняют ваш дом теплом и уютом, используя только натуральные материалы
          </p>
        </div>
        <div className="grid md:grid-cols-3 gap-8">
          {benefits.map((benefit, index) => (
            <div
              key={index}
              className="p-6 rounded-2xl bg-white shadow-lg hover:shadow-xl transition-all"
            >
              <div className="w-12 h-12 rounded-full bg-honey-100 flex items-center justify-center mb-4 mx-auto">
                <benefit.icon className="w-6 h-6 text-honey-600" />
              </div>
              <h3 className="text-xl font-bold mb-2 text-center">{benefit.title}</h3>
              <p className="text-gray-600 text-center">{benefit.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Benefits;
